(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* StickyHeader (smart sticky nav row) is defined in assets/abano.js so that it also runs in the
     local preview harness; this block only keeps the account-dialog positioning. */
  class StickyHeaderLegacy extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    /* Reference behaviour ("smart sticky"): once the page is scrolled past the
       navigation row, only that row (80px, no logo) is pinned to the top. It hides
       on scroll-down and reappears on scroll-up. Below 1200px the whole 100px mobile
       header is position:sticky via CSS and this class does nothing. */
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerEl = this.querySelector('.header');
      this.navRow = this.querySelector('.header__nav-row');
      this.desktopMediaQuery = window.matchMedia('(min-width: 1200px)');
      this.headerBounds = {};

      this.setHeaderHeight();
      this.desktopMediaQuery.addEventListener('change', () => { this.reset(); this.setHeaderHeight(); });

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.setHeaderHeight);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
    }

    navBottom() {
      if (!this.navRow || !this.headerEl) return 0;
      const fixed = this.headerEl.classList.contains('header--nav-fixed');
      const top = this.headerEl.getBoundingClientRect().top + window.pageYOffset;
      return top + this.headerEl.offsetHeight - (fixed ? 0 : 0);
    }

    onScroll() {
      if (!this.desktopMediaQuery.matches || !this.navRow) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      const threshold = this.navBottom();
      if (scrollTop > threshold) {
        this.headerEl.classList.add('header--nav-fixed');
        if (scrollTop > this.currentScrollTop) {
          if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
        } else if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.headerEl.classList.add('header--nav-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.headerEl.classList.remove('header--nav-hidden');
    }

    reset() {
      if (!this.headerEl) return;
      this.headerEl.classList.remove('header--nav-fixed', 'header--nav-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeaderLegacy);

  } catch(e) { console.error(e); }
})();
})();
